import React, { useContext } from 'react';

import LoadingPage from '../../components/LoadingPage';

import FirebaseContext from './FirebaseContext';

import FirebaseContextProvider from './FirebaseContextProvider';

const withFirebaseContextReady = (Component) => (props) => {
  const { isReady } = useContext(FirebaseContext);
  return isReady ? <Component {...props} /> : <LoadingPage />;
};

const withFirebaseContextProvider = (Component) => (props) => (
  <FirebaseContextProvider>
    <Component {...props} />
  </FirebaseContextProvider>
);

export {
  withFirebaseContextReady,
  withFirebaseContextProvider,
};
